import { useEffect, useMemo, useState } from "react";
import {
  AutoComplete,
  // Button, Flex, 
  Form, Input, Modal, Select, Space, Spin, Table, TableColumnsType, TableProps, Tabs
} from "antd";
import '@xyflow/react/dist/style.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { operationCreateRequest, operationListRequest } from "src/store/actions/operations";
import { StoreState } from "src/store/configureStore";
import { LoadingOutlined } from "@ant-design/icons";
import { AsyncStates } from "src/constants";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

interface Values {
  title?: string;
  description?: string;
  modifier?: string;
}

const columns: TableColumnsType<DataType> = [
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text: string) => text,
  },
  {
    title: 'Category',
    dataIndex: 'category',
  },
  {
    title: 'Customer',
    dataIndex: 'address',
  },
  {
    title: 'Created By',
    dataIndex: 'createdBy',
  },
  {
    title: 'Added On',
    dataIndex: 'addedOn',
  },
];

// rowSelection object indicates the need for row selection
const rowSelection: TableProps<DataType>['rowSelection'] = {
  onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  getCheckboxProps: (record: DataType) => ({
    disabled: record.name === 'Disabled User', // Column configuration not to be checked
    name: record.name,
  }),
};

export const Operations = ({ open, setOpen }: { open: boolean, setOpen: (open: boolean) => void }) => {
  const [selectionType] = useState<'checkbox' | 'radio'>('checkbox');
  const [form] = Form.useForm();
  const [, setFormValues] = useState<Values>();

  const dispatch = useDispatch()

  const onCreate = (values: Values) => {
    dispatch(operationCreateRequest(values))
    form.resetFields();
    setFormValues({ id: crypto.randomUUID() } as any);
    setOpen(false);
  };

  const onChange = (key: string) => {
    console.log(key);
  };

  const { push } = useHistory()

  useEffect(() => {
    dispatch(operationListRequest())
  }, [dispatch])

  const operationList = useSelector((state: StoreState) => state.operations.operationListData)
  const { dataset_types: datasetTypes } = useSelector((state: StoreState) => state.operations.operationConfigsData)
  const operationData = useMemo(() => operationList?.map((o: any) => ({ key: o.id, ...o })), [operationList])
  const operationListStatus = useSelector((state: StoreState) => state.operations.operationListStatus)

  return (
    <Spin spinning={operationListStatus === AsyncStates.LOADING} indicator={<LoadingOutlined />}>
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Table<DataType>
          rowSelection={{ type: selectionType, ...rowSelection }}
          columns={columns}
          dataSource={operationData}
          onRow={(record, rowIndex) => ({ onClick: () => { push(`/ai-engine/operations/${record.key}/details`) } })}
        />
      </Space>
      <Modal
        title="Create New Operation"
        open={open}
        okText="Create"
        cancelText="Cancel"
        okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
        onCancel={() => { setOpen(false); form.resetFields(); setFormValues({ id: crypto.randomUUID() } as any) }}
        destroyOnClose
        modalRender={dom => (
          <Form
            layout="vertical"
            form={form}
            name="form_in_modal"
            initialValues={{ dataset_types: datasetTypes.map((type: any) => type.id) }}
            onFinish={(values) => onCreate(values)}
          >
            {dom}
          </Form>
        )}
      >
        <Tabs size="small" defaultActiveKey="new_operation" items={[
          {
            key: 'new_operation',
            label: 'Add New',
            children: (
              <>
                <br />
                <Form.Item name="id" initialValue={crypto.randomUUID()} hidden />
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: 'Please input the title of operation!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item name="category" label="Category">
                  <AutoComplete
                    options={[]}
                    placeholder="Please input the category"
                    filterOption={(inputValue, option) =>
                      option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                  />
                </Form.Item>
                <Form.Item name="dataset_types" label="Dataset Types">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    defaultValue={datasetTypes.map((type: any) => type.id)}
                    value={datasetTypes.map((type: any) => type.id)}
                    options={datasetTypes?.map((type: any) => ({ value: type.id, label: type.name, disabled: type.id === "DATASET" }))}
                  />
                </Form.Item>
                {/* <Flex justify="flex-end">
                  <Button size="small" type="link" onClick={() => { push("/ai-engine/operations/new") }}>+ Add More Details</Button>
                </Flex> */}
                <br />
              </>
            ),
          },
          // {
          //   key: 'operation_templates',
          //   label: 'Templates',
          //   children: 'Content of Tab Pane 2',
          // }
        ]}
          onChange={onChange}
        />
      </Modal>
    </Spin>
  );
}

// const AddNew = () => {
//   return (
//     <Form
//   )
// }